import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LearningPage from './pages/LearningPage';
import DMBoKPage from './pages/DMBoKPage';
import DMBoK3Page from './pages/DMBoK3Page';
import NewsPage from './pages/NewsPage';
import EventsPage from './pages/EventsPage';
import InsightsPage from './pages/InsightsPage';
import MembershipPage from './pages/MembershipPage';
import AboutPage from './pages/AboutPage';
import ChaptersBoardPage from './pages/ChaptersBoardPage';
import AuthPage from './pages/AuthPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"               element={<HomePage />} />
        <Route path="/learning"       element={<LearningPage />} />
        <Route path="/dmbok"          element={<DMBoKPage />} />
        <Route path="/dmbok3"         element={<DMBoK3Page />} />
        <Route path="/news"           element={<NewsPage />} />
        <Route path="/events"         element={<EventsPage />} />
        <Route path="/insights"       element={<InsightsPage />} />
        <Route path="/membership"     element={<MembershipPage />} />
        <Route path="/about"          element={<AboutPage />} />
        <Route path="/chapters-board" element={<ChaptersBoardPage />} />
        <Route path="/login"          element={<AuthPage />} />
      </Routes>
    </Router>
  );
}

export default App;